import React, { useRef } from 'react';
import { Overlay } from './Overlay';
import { BriefSectionView } from './BriefSectionView';
import { ContentsNav } from './ContentsNav';
import { ConceptUsage } from './ConceptUsage';
import { useActiveSection } from '../../hooks/useActiveSection';
import { briefClosing, briefSections, briefSubtitle } from '../../data/brief';
import type { Format } from '../../types/snak';
interface ConceptOverlayProps {
  format: Format;
  onFormatChange: (format: Format) => void;
  onClose: () => void;
}
export function ConceptOverlay({
  format,
  onFormatChange,
  onClose
}: ConceptOverlayProps) {
  const compact = format === 'mobile';
  const bodyRef = useRef<HTMLDivElement>(null);
  const active = useActiveSection(briefSections.map(s => s.id), bodyRef, !compact);
  const goTo = (id: string) => {
    const element = document.getElementById(id);
    if (element) element.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <Overlay eyebrow="Concept & strategy" format={format} onFormatChange={onFormatChange} onClose={onClose} bodyRef={bodyRef} data-id="element-123" data-mp="953je5mjxlwq">
      <div className={compact ? 'px-6 pb-14 pt-10' : 'mx-auto flex max-w-[1160px] items-start gap-12 px-8 pb-24 pt-14 lg:gap-16'} data-id="element-124" data-mp="1gzi882q1648n">
        {!compact && <ContentsNav variant="rail" active={active} onSelect={goTo} className="hidden lg:block" data-id="element-125" data-mp="1ptdcl8jbvqn8" />}

        <div className={compact ? '' : 'min-w-0 max-w-[700px] flex-1'} data-id="element-126" data-mp="y2h1accx1u22">
          <h1 className={['font-heading leading-[0.96] tracking-[-0.03em] text-background', compact ? 'text-[34px]' : 'text-[46px] sm:text-[56px]'].join(' ')} data-id="element-127" data-mp="1c0x8e4eoxmkq">
            Meet the Filteks
          </h1>
          <p className={['max-w-[28ch] font-heading leading-[1.25] tracking-[-0.01em] text-[rgba(1,51,43,0.6)]', compact ? 'mt-4 text-[16px]' : 'mt-5 text-[21px]'].join(' ')} data-id="element-128" data-mp="2nigeq5nki5ni">
            {briefSubtitle}
          </p>

          {compact && <ContentsNav variant="index" active={active} onSelect={goTo} className="mt-8" data-id="element-129" data-mp="2uleiawz1n6i1" />}

          <div className={compact ? 'mt-12 space-y-12' : 'mt-16 space-y-16'} data-id="element-130" data-mp="34gye7jdly56s">
            {briefSections.map((section, i) => <BriefSectionView key={section.id} section={section} index={i} compact={compact} data-id="element-131" data-mp="2bt28xq9z34ye" data-mpi={i} />)}
          </div>

          <section className={['border-t border-[rgba(1,51,43,0.14)]', compact ? 'mt-12 pt-8' : 'mt-16 pt-10'].join(' ')} data-id="element-132" data-mp="2livmgwtodu5a">
            <p className={['max-w-[24ch] font-heading leading-[1.06] tracking-[-0.02em] text-background', compact ? 'text-[25px]' : 'text-[34px]'].join(' ')} data-id="element-133" data-mp="1t2kv0rtsudx3">
              {briefClosing.statement}
            </p>
            <p className={['mt-4 font-heading leading-tight text-[rgba(1,51,43,0.55)]', compact ? 'text-[17px]' : 'text-[22px]'].join(' ')} data-id="element-134" data-mp="1gi4cow7ez9zs">
              {briefClosing.support}
            </p>
          </section>

          <footer className={['border-t border-[rgba(1,51,43,0.12)]', compact ? 'mt-12 pt-6' : 'mt-16 pt-8'].join(' ')} data-id="element-135" data-mp="12madj4wfzyzv">
            <p className="font-body text-[12px] leading-relaxed text-[rgba(1,51,43,0.55)]" data-id="element-136" data-mp="sunuwnhryxn3">
              Original concept &amp; creative direction by Snakker™
            </p>
            <ConceptUsage data-id="element-137" data-mp="iv5fmkct801d" />
          </footer>
        </div>
      </div>
    </Overlay>;
}